import Vue from "vue";
import Router from "vue-router";
// import LoginPage from "@/components/pages/Login";
import SignupPage from "@/components/pages/Signup";
import PasswordResetPage from "@/components/pages/PasswordReset";
import PasswordForgotPage from "@/components/pages/PasswordForgot";
import AdminPage from "@/components/pages/Admin";
import OrdersPage from "@/components/pages/Orders/list-new";
// import OrdersPrintPage from "@/components/pages/Orders/print";
import OrdersCreatePage from "@/components/pages/Orders/create";
import FormsPage from "@/components/pages/Forms/list";
import FormsConfigurePage from "@/components/pages/Forms/configure";
import FormsCrudPage from "@/components/pages/Forms/crud";
import FormsEditPage from "@/components/pages/Forms/edit";
import FormsCreatePage from "@/components/pages/Forms/create";
import FormDisambiguationPage from "@/components/pages/Forms/disambiguation";
import FormShowPage from "@/components/pages/Forms/show";
import UsersPage from "@/components/pages/Users/list-new";
import VettedNotesPage from "@/components/pages/VettedStatement/list";
import AssetsPage from "@/components/pages/Assets/list";
import AssetsOfflinePage from "@/components/pages/AssetsOffline/list";
import AssetsOfflineDeveloperPage from "@/components/pages/AssetsOffline/developer";
import ServiceLevelsPage from "@/components/pages/ServiceLevels/list";
import ProfilePage from "@/components/pages/Profile";
import SetPasswordPage from "@/components/pages/SetPassword";
import ConfigurationsPage from "@/components/pages/Configurations/list";
import TagsPage from "@/components/pages/Tags/list";
import CodesPage from "@/components/pages/Codes";
import CodesListPage from "@/components/pages/Codes/list";
import CodeConfiguratorPage from "@/components/pages/codeConfigurator";
import CodesMatrixManagerPage from "@/components/pages/CodesMatrixManager";
import CodesChainPage from "@/components/pages/Codes/chain";
import RolesPage from "@/components/pages/Roles";
import NotificationsPage from "@/components/pages/Notifications/list";
import LogsPage from "@/components/pages/Logs/list";
import OrderPdfTemplatePage from "@/components/pages/Templates/order-pdf";

import AutomatedTestingPage from "@/components/pages/UILicious/list";
import Portals from "@/components/pages/Portals";

import Invoices from "@/components/pages/invoices/index";
import Batches from "@/components/pages/Batches/index";

/* import Documents from "@/components/pages/Documents/index"; */
import Documents from "@/components/pages/Documents/list";

import Permissions from "@/helpers/permissions";
import Roles from "@/helpers/roles";

import Organizations from "@/components/pages/Organization/index";
import View from "@/components/View/index";
import Operations from "@/components/pages/Operations";
import OperationForm from "@/components/pages/Operations/form";
// import Organizations from "@/components/pages/Users/list-new/index-original";
import TemplatesPage from "@/components/pages/Templates";
import TemplatesCreatePage from "@/components/pages/Templates/create";
import TemplatesEditPage from "@/components/pages/Templates/edit";
import MobileRedirectComponent from "@/components/pages/Mobile/index";

import LoginPage from "@/components/pages/Login/auth0";
import ErrorsContactPage from "@/components/pages/Errors/contact";

import OrdersScheduler from "@/components/pages/OrdersScheduler";

import Guide from "@/components/pages/Guide";

import Tests from "@/components/pages/Tests";

import AuthUtil from "@/utils/auth.util";

Vue.use(Router);

export default new Router({
  mode: "history",
  // https://router.vuejs.org/guide/advanced/scroll-behavior.html
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/",
      redirect: {
        name: "login"
      }
    },
    {
      path: "/login",
      name: "login",
      component: LoginPage,
      meta: {
        public: true // doesn't require authenticated user
      }
    },
    {
      path: "/signup",
      name: "signup",
      component: SignupPage,
      meta: {
        public: true // doesn't require authenticated user
      }
    },
    {
      path: "/password-set",
      name: "password-set",
      component: SetPasswordPage,
      meta: {
        public: true // doesn't require authenticated user
      }
    },
    {
      path: "/password-reset/:token",
      name: "password-reset",
      component: PasswordResetPage,
      meta: {
        public: true // doesn't require authenticated user
      }
    },
    {
      path: "/password-forgot",
      name: "password-forgot",
      component: PasswordForgotPage,
      props: true,
      meta: {
        public: true // doesn't require authenticated user
      }
    },
    {
      path: "/errors/contact-healthy-waters",
      name: "errors-contact",
      component: ErrorsContactPage,
      meta: {
        public: true // doesn't require authenticated user
      }
    },
    {
      path: "/admin",
      name: "admin",
      component: AdminPage
    },
    {
      path: "/orders",
      name: "order-list",
      props: true,
      component: OrdersPage,
      meta: {
        permissions: [Permissions.CAN_VIEW_ORDERS]
      },
      children: [
          {

            path: '?orderId=1234234',
            name: "order-list-asd",

          }
      ]
    },
    // {
    //   path: "/orders/:id/print",
    //   name: "order-print",
    //   props: true,
    //   component: OrdersPrintPage,
    //   meta: {
    //     permissions: [Permissions.CAN_VIEW_ORDERS]
    //   }
    // },
    {
      path: "/view",
      name: "view",
      component: View,
      props: true,
      meta: {
        // permissions: [Permissions.CAN_VIEW_ORDERS]
      }
    },
    {
      path: "/orders/create",
      name: "order-create",
      component: OrdersCreatePage,
      props: true,
      meta: {
        permissions: [Permissions.CAN_VIEW_ORDERS]
      }
    },
    {
      path: "/orders/:id/update",
      name: "order-update",
      component: OrdersCreatePage,
      props: true,
      meta: {
        permissions: [Permissions.CAN_VIEW_ORDERS]
      }
    },
    {
      path: "/forms/disambiguation",
      name: "form-disambiguation",
      component: FormDisambiguationPage
    },
    {
      path: "/forms",
      name: "form-list",
      component: FormsPage,
      meta: {
        permissions: [Permissions.CAN_VIEW_INSPECTIONS]
      }
    },
    {
      path: "/forms/create",
      name: "form-create",
      component: FormsCreatePage,
      meta: {
        permissions: [Permissions.CAN_MANAGE_INSPECTIONS]
      }
    },
    {
      path: "/forms/:id/edit",
      name: "form-edit",
      component: FormsEditPage,
      meta: {
        back: { name: "form-list" },
        permissions: [Permissions.CAN_MANAGE_INSPECTIONS]
      }
    },
    {
      path: "/forms/:id",
      name: "form-show",
      component: FormShowPage,
      meta: {
        back: { name: "form-list" },
        permissions: [Permissions.CAN_VIEW_INSPECTIONS]
      }
    },
    // {
    //   path: "/formio",
    //   name: "formio",
    //   component: FormsCrudPage,
    // },
    {
      path: "/formio",
      name: "formio",
      component: {
        created() {
          window.location.replace('/formio');
        }
      }
    },
    {
      path: "/assets",
      name: "asset-list",
      component: AssetsPage,
      meta: {
        permissions: [Permissions.CAN_VIEW_ASSETS]
      }
    },
    {
      path: "/operations",
      name: "operations",
      component: Operations,
      meta: {
        permissions: [Permissions.CAN_MANAGE_OPERATIONS]
      }
    },
    {
      path: "/operation/create",
      name: "operationCreate",
      component: OperationForm,
      meta: {
        permissions: [Permissions.CAN_MANAGE_OPERATIONS]
      }
    },
    {
      path: "/operation/update/:id",
      name: "operationUpdate",
      component: OperationForm,
      meta: {
        permissions: [Permissions.CAN_MANAGE_OPERATIONS]
      }
    },
    {
      path: "/invoices",
      name: "invoices",
      component: Invoices,
      meta: {
        permissions: [Permissions.CAN_VIEW_INVOICES]
      }
    },
    {
      path: "/batches",
      name: "batches",
      component: Batches,
      meta: {
        permissions: [Permissions.CAN_VIEW_BATCHES]
      }
    },
    {
      path: "/organisations",
      name: "organisations",
      component: Organizations,
      meta: {
        // reverseRoles: [Roles.SUPERADMIN] // could be useful feature but no longer needed here.
        permissions: [Permissions.CAN_VIEW_FIRMS]
      }
    },
    {
      path: "/assets-offline",
      name: "asset-offline-list",
      component: AssetsOfflinePage,
      meta: {
        permissions: [Permissions.CAN_VIEW_ASSETS]
      }
    },
    {
      path: "/assets-offline/developer",
      name: "asset-offline-developer",
      component: AssetsOfflineDeveloperPage,
      meta: {
        permissions: [Permissions.CAN_VIEW_ASSETS]
      }
    },
    {
      path: "/profile",
      name: "profile",
      component: ProfilePage
    },
    {
      path: "/documents",
      name: "documents",
      component: Documents,
      meta: {
        permissions: [Permissions.CAN_VIEW_DOCUMENTS]
      },
    },
    {
      path: "/configuration",
      name: "configuration",
      component: ConfigurationsPage,
      meta: {
        roles: ["superadmin"]
      },
      children: [
        {
          path: "users",
          name: "configuration.users",
          component: UsersPage,
          meta: {
            permissions: ["can manage users"]
          }
        },
        {
          path: "vetted-notes",
          name: "configuration.vetted-notes",
          component: VettedNotesPage,
          meta: {
            permissions: ["can manage vetted notes"]
          }
        },
        {
          path: "codes",
          name: "configuration.codes",
          component: CodesPage,
          redirect: { name: "codes.list" },
          meta: {
            permissions: ["can manage codes"]
          },
          children: [
            {
              path: "",
              name: "codes.list",
              component: CodesListPage
            },
            {
              path: "configurator",
              name: "codes.configurator",
              component: CodeConfiguratorPage
            },
            {
              path: "matrix-manager",
              name: "codes.matrix-manager",
              component: CodesMatrixManagerPage
            },
            {
              path: "chain",
              name: "codes.chain",
              component: CodesChainPage
            }
          ]
        },
        {
          path: "service-levels",
          name: "configuration.service-levels",
          component: ServiceLevelsPage,
          meta: {
            permissions: ["can manage service levels"]
          }
        },
        {
          path: "roles",
          name: "configuration.roles",
          component: RolesPage,
          meta: {
            permissions: ["can manage roles"],
            // roles: ['superadmin']
          }
        },
        {
          path: "tags",
          name: "configuration.tags",
          component: TagsPage,
          meta: {
            permissions: ["can manage tags"]
          }
        },
        {
          path: "notifications",
          name: "configuration.notifications",
          component: NotificationsPage,
          meta: {
            permissions: ["can view notifications"],
            roles: ['superadmin']
          }
        },
        {
          path: "logs",
          name: "configuration.logs",
          component: LogsPage,
          meta: {
            roles: ["superadmin"]
          }
        },
        {
          path: "automated-testing",
          name: "configuration.automated-testing",
          component: AutomatedTestingPage,
          meta: {
            permissions: ["can view tests"]
          }
        },
        {
          path: "portals",
          name: "configuration.portals",
          component: Portals,
          meta: {
            permissions: []
          }
        },
        {
          path: "order-pdf-template",
          name: "configuration.order-pdf-template",
          component: OrderPdfTemplatePage,
          meta: {
            permissions: ["can manage templates"]
          }
        },
        {
          path: "templates",
          name: "configuration.templates",
          component: TemplatesPage,
          meta: {
            permissions: ["can manage templates"]
          }
        },

        {
          path: "templates/create",
          name: "configuration.templates.create",
          component: TemplatesCreatePage,
          meta: {
            permissions: ["can manage templates"]
          }
        },
        {
          path: "templates/:id/edit",
          name: "configuration.templates.edit",
          component: TemplatesEditPage,
          meta: {
            permissions: ["can manage templates"]
          }
        }
      ]
    },
    {
      path: "/missions",
      name: "mission",
      redirect: to => {
        window.location.replace(process.env.STORMPORT_ASSETS_URL);
        return;
      }
    },
    {
      path: "/mobile",
      name: "mobile",
      component: MobileRedirectComponent,
      /*
      redirect: to => {
        window.location.replace(process.env.STORMPORT_MOBILE_APP_URL+'?start_route=1');
        return;
      }
      */
    },
    {
      path: "/schedular",
      name: "schedular",
      component: OrdersScheduler,
    },
    // {
    //   path: '*',
    //   redirect: '/login'
    // },
    {
      path: '*',
      redirect: (to) => {
        const path = to.path;
        if (/\.\w+$/.test(path)) { // check if path ends with a file extension
          return { path: path };
        } else {
          return { path: "/login" };
        }
      },
    },
    {
      path: "/guide",
      name: "guide",
      component: Guide,
    },
    {
      path: "/tests",
      name: "tests",
      component: Tests,
    },
    {
      path: "/aklc-pwa",
      name: "aklc-pwa",
      redirect: to => {
        const token = AuthUtil.getAuthToken();
        window.location.replace(process.env.STORMPORT_PWA_URL + `?token=${token}`);
        return;
      },
    },
    {
      path: "/q",
      name: "quasar",
      component: {
        created() {
          window.location.replace('/q');
        }
      }
    },
  ]
});


// WEBPACK FOOTER //
// ./src/router/index.js